// @flow

import React from 'react'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import Colors from 'components/styles/colors'
import { mediaMin } from 'frontend_core/dist/styles/media'
import {
  fontSize,
  spacing,
  borderRadius,
} from 'frontend_core/dist/styles/variables'
import OptimizedImage from 'components/atoms/OptimizedImage'
import { type FavoriteList } from 'types/favorite'
import { imagePath } from 'frontend_core/dist/helpers/image'

const Container = styled.div`
  background-color: ${Colors.white};
  border-radius: ${borderRadius}px;
  overflow: hidden;
`

const Head = styled.div`
  border-radius: ${borderRadius}px;
  overflow: hidden;
`

const Body = styled.div`
  display: block;
  padding-top: ${spacing.small_3}px;
`

const Title = styled.h2`
  color: ${Colors.black};
  font-size: ${fontSize.small_3}px;
  font-weight: bold;
  line-height: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

const SpaceNum = styled.p`
  margin-top: ${spacing.small}px;
  color: ${Colors.gray9};
  font-size: ${fontSize.small_2}px;
  line-height: 1;
`

const OptimizedImageWrapper = styled.div`
  position: relative;
  padding-top: 66.666%;
`

export type PropTypes = FavoriteList

export default class FavoriteListCard extends React.Component<PropTypes, *> {
  props: PropTypes

  render() {
    const { id, total_favorites: totalFavorites, thumbnail, name } = this.props

    return (
      <Link to={`/dashboard/favorite_lists/${id || ''}`}>
        <Container>
          <Head>
            <OptimizedImageWrapper>
              <OptimizedImage
                src={thumbnail || imagePath('common/noimage_search.png')}
                alt={name}
                type="cover"
              />
            </OptimizedImageWrapper>
          </Head>
          <Body>
            <Title>{name}</Title>
            <SpaceNum>
              {i18n.t('page.dashboard.favorite.NumberOfSpace', {
                spaceNum: totalFavorites,
              })}
            </SpaceNum>
          </Body>
        </Container>
      </Link>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/molecules/FavoriteListCard/index.jsx